export enum ProjectAccessLevel {
  PRIVATE = 'private',
  VIEW_ONLY = 'view_only',
  PUBLIC = 'public',
  OPEN_GUEST = 'open_guest'
}
